import React from "react";
import { useMediaQuery } from "react-responsive";

const SectionSeven: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div className="product-section-seven">
            <div className="container-fluid container-fluid-seven">
                <div> <h2 className="supercharge-business-seven">
                    Grievance Redressal Officer
                </h2>

                    <div className="contact-info">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="none" stroke="#000" strokeWidth="1.5" viewBox="0 0 24 24">
                                <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4Z" />
                                <path d="M4 20c0-2.21 3.582-4 8-4s8 1.79 8 4" />
                            </svg>
                            <strong>Sandeep Rastogi</strong>
                        </div>

                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="none" stroke="#000" strokeWidth="1.5" viewBox="0 0 24 24">
                                <path d="M21 16.5c-.75 0-2.25-1.5-3-1.5s-1.5.75-2.25 1.5c-.75.75-2.25-.75-3-1.5-1.125-1.125-2.25-2.25-3-3s-2.25-2.25-1.5-3 1.5-1.5 1.5-2.25S7.5 3.75 7.5 3H3c0 9.389 7.611 17 17 17v-4.5Z" />
                            </svg>
                            <span>9718585484</span>
                        </div>

                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="none" stroke="#000" strokeWidth="1.5" viewBox="0 0 24 24">
                                <path d="M4 4h16v16H4V4Z" />
                                <path d="M4 4l8 8 8-8" />
                            </svg>
                            <span>grievanceofficer.kfs@gokwik.co</span>
                        </div>

                        <div style={{ maxWidth: "400px" ,display:"flex"}}>
                            <svg xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="36"
                                fill="none" stroke="#000" strokeWidth="1.5" viewBox="0 0 24 24">
                                <path d="M12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
                                <path d="M19.5 9.5c0 7-7.5 12-7.5 12s-7.5-5-7.5-12a7.5 7.5 0 1 1 15 0Z" />
                            </svg>
                            <div >
                                6th Floor, Tower B, Paras Twin Towers,
                                Suncity, Sector 54, Gurugram, Haryana 122022
                            </div>
                        </div>
                    </div>

                </div>
                <div className="Grievance-img">
                    <img src="/assets/images/Grievanceoffice.png" alt="" />
                </div>

            </div>
        </div>
    );
};

export default SectionSeven;
